import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchDeletePromisedData, getDropdownIdsFromSelectArray, getDropdownLabelsFromSelectArray } from "../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { hardcodeDropdown } from '../../common/services';
import { fetchBusinessAreasByUnitType } from "views/pages/manage/academicPlanAndTest/constant/common";

export const getConfigs = async (filterObj) => {
    return await fetchAllPostPromisedData(endpoint?.refund?.approvalConfig?.search, filterObj);
}

export const createConfig = async (form) => {
    let reqObj = createRefundConfigReqObj(form);
    return await fetchAllPostPromisedData(endpoint?.refund?.approvalConfig?.basePath, reqObj);
}

export const updateConfig = async (form) => {
    let reqObj = createRefundConfigReqObj(form);
    return await fetchAllPostPromisedData(endpoint?.refund?.approvalConfig?.basePath, reqObj, 'put');
}

export const getDropdownAsNumberArray = (items) =>
    items?.map((item) => Number(item?.value));

const createRefundConfigReqObj = (form) => {
    const { businessArea = [], branchType, approvalSettingDTO = [], approvalConfigNumber } = form;

    const hasRecords = approvalSettingDTO?.length > 0;

    return hasRecords
        ? {
            requestDtos: approvalSettingDTO.map((el) => {
                const { subType, isLoanComponent, amount, roleApprovals = {}, approvalConfigNumber, status, cashierOffice } = el;
                const { LEVEL_1 = [], LEVEL_2 = [], LEVEL_3 = [] } = roleApprovals;
                const isNew = String(el?.id)?.includes("n");

                return {
                    id: isNew ? null : el?.id,
                    type: "REFUND",
                    subType: subType?.value,
                    approvalConfigNumber,
                    roleApprovals: {
                        ...(LEVEL_1?.length ? { LEVEL_1: getDropdownAsNumberArray(LEVEL_1) } : {}),
                        ...(LEVEL_2?.length ? { LEVEL_2: getDropdownAsNumberArray(LEVEL_2) } : {}),
                        ...(LEVEL_3?.length ? { LEVEL_3: getDropdownAsNumberArray(LEVEL_3) } : {}),
                    },
                    isLoanComponent: isLoanComponent?.value,
                    amount: +amount,
                    branchType: branchType?.[0]?.label ?? "",
                    businessArea: getDropdownLabelsFromSelectArray(businessArea),
                    cashier: getDropdownLabelsFromSelectArray(form.cashierOffice),
                    status: status ?? "INACTIVE",
                };
            })
        }
        : {
            requestDtos: [
                {
                    approvalConfigNumber,
                    branchType: branchType?.[0]?.label ?? "",
                    businessArea: getDropdownLabelsFromSelectArray(businessArea),
                    cashier: getDropdownLabelsFromSelectArray(form.cashierOffice),
                }
            ]
        };
};




export const getFilterReqObj = (filters, allActiveBu) => {
    const { subTypes = [], businessAreas = [] } = filters;

    return {
        subTypes: subTypes?.length ? subTypes.map(st => st?.value) : [],
        businessAreas: businessAreas?.length
            ? getDropdownLabelsFromSelectArray(businessAreas)
            : []
    };
};

export const deleteRecord = async (id, setLoading) => {
    try {
        setLoading(true);
        let resp = await fetchDeletePromisedData(`${endpoint?.refund?.approvalConfig?.basePath}/${id}`)
        if (resp?.code === 200) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        console.log(e);
    } finally {
        setLoading(false);
    }
}


export const getFormattedRefundConfig = (respData, dropdownData) => {
    const { allActiveBu, allActiveRoles, branchType } = dropdownData;

    return respData?.map(item => {
        const branchInfo = item?.branchApprovalDtoList?.[0] || {};
        // branchInfo?.branchType = businessArea
        return {
            branchType: branchInfo?.branchType?.map(bt => branchType.find(t => t.label?.toLowerCase() == bt?.toLowerCase())) || [],
            businessArea: branchInfo?.businessArea?.map(ba => allActiveBu.find(bu => bu.label === ba)) || [],
            cashier: Array.isArray(branchInfo?.cashier)
                ? branchInfo.cashier
                    .filter(c => c != null && c !== "")
                    .map(c => ({
                        label: c,
                        value: c
                    }))
                : [],
            cashierOffice: branchInfo?.cashier?.map(c => allActiveBu.find(bu => bu.label === c)) || [],

            approvalSettingDTO: item?.approvalConfigResponseDTOList?.map(cfg => ({
                id: cfg?.id,
                type: cfg?.type,
                subType: hardcodeDropdown?.subType?.find(el => el?.value == cfg?.subType),
                isLoanComponent: hardcodeDropdown?.isLoanComponent?.find(el => el?.value == cfg?.isLoanComponent),
                amount: cfg?.amount,
                createdBy: cfg?.createdBy,
                updatedBy: cfg?.updatedBy,
                createdOn: cfg?.createdOn,
                updatedOn: cfg?.updatedOn,
                approvalConfigNumber: cfg?.approvalConfigNumber,
                status: cfg?.status,
                roleApprovals: Object.keys(cfg?.roleApprovals || {}).reduce(
                    (acc, level) => {
                        acc[level] = cfg.roleApprovals[level]?.map(roleId =>
                            allActiveRoles?.find(r => r?.value == roleId)
                        );
                        return acc;
                    },
                    {}
                ),
            }))
        }

    });
}

export const REFUND_CONFIG_FILTER_FORM_FIELDS = {
    businessAreas: "",
    subTypes: ""
}

export const getBuAgainstBuTypes = async (buTypes, setBuLoading) => {
    try {
        setBuLoading(true);
        if (!buTypes) return [];
        const buTypesArray = Array.isArray(buTypes) ? buTypes : [buTypes];
        const buAgainstBuTypes = await fetchBusinessAreasByUnitType(
            getDropdownIdsFromSelectArray(buTypesArray)
        );
        return buAgainstBuTypes;
    } catch (e) {
        console.error(e);
        return [];
    } finally {
        setBuLoading(false);
    }
};